import React from "react";
import {
  List,
  Datagrid,
  TextField,
  Create,
  TextInput,
  Edit,
  Delete,
  Filter,
  ReferenceInput,
  SelectInput,
  EditButton,
  TabbedForm,
  FormTab,
  ReferenceField
} from "admin-on-rest/lib/mui";

import Gallery from "../custom/gallery_products";
import RichTextInput from "aor-rich-text-input";
import { RichTextField, required } from "admin-on-rest";
import CustomImageField from "../custom/imageSize";

const DestinationFilter = props => (
  <Filter {...props}>
    <TextInput label="resources.title.name" source="title" alwaysOn />
    <ReferenceInput
      label="resources.companies.name"
      source="CompanyID"
      reference="companies"
      allowEmpty
      alwaysOn
      perPage={1000}
    >
      <SelectInput optionText={choice => `${choice.name}`} />
    </ReferenceInput>
    <ReferenceInput
      label="resources.branches.name"
      source="BranchID"
      reference="branches"
      allowEmpty
      alwaysOn
      perPage={1000}
    >
      <SelectInput
        optionText={choice => `${choice.tmima + " " + choice.address}`}
      />
    </ReferenceInput>
  </Filter>
);

export const ProductsList = props => (
  <List
    {...props}
    filters={<DestinationFilter />}
    title="resources.management_product.name"
  >
    <Datagrid>
      <CustomImageField
        width={200}
        height={125}
        source="gallery[0]"
        label="resources.image.name"
      />
      <TextField source="title" label="resources.title.name" />
      <RichTextField label="resources.description.name" source="description" />
      <ReferenceField
        label="resources.branches.name"
        source="BranchID"
        reference="branches"
      >
        <TextField source="tmima_address" />
      </ReferenceField>

      <EditButton />
    </Datagrid>
  </List>
);

const userType = localStorage.getItem("permissions");

export const CreateProduct = props => (
  <Create {...props}>
    <TabbedForm redirect="list">
      <FormTab label="general">
        <TextInput
          label="resources.title.name"
          source="title"
          validate={required}
        />
        <RichTextInput
          label="resources.description.name"
          source="description"
          validate={required}
        />
        {userType === 'SuperUser' &&
          <ReferenceInput
            label="resources.companies.name"
            source="CompanyID"
            reference="companies"
            allowEmpty
            alwaysOn
          >
            <SelectInput optionText={choice => `${choice.name}`} />
          </ReferenceInput>}
        {
          //  <DependentInput dependsOn="CompanyID" >
          //  <TextField label="Υποκατάστημα" />
          //  <SubGenreInput />
          // </DependentInput>
        }
        <ReferenceInput
          label="resources.branches.name"
          source="BranchID"
          reference="branches"
          allowEmpty
          alwaysOn
          perPage={1000}
        >
          <SelectInput
            optionText={choice => `${choice.tmima + " " + choice.address}`}
          />
        </ReferenceInput>
      </FormTab>
      <FormTab label="photos">
        <Gallery source="gallery" />
      </FormTab>
    </TabbedForm>
  </Create>
);

const PostTitle = ({ record }) => {
  return <span>{record ? `${record.title}` : ""}</span>;
};

export const EditProduct = props => (
  <Edit title={<PostTitle />} {...props}>
    <TabbedForm>
      <FormTab label="general">
        <TextInput
          label="resources.title.name"
          source="title"
          validate={required}
        />
        <RichTextInput
          label="resources.description.name"
          source="description"
          validate={required}
        />
        <ReferenceInput
          label="resources.branches.name"
          source="BranchID"
          reference="branches"
          allowEmpty
        >
          <SelectInput
            optionText={choice => `${choice.tmima + " " + choice.address}`}
          />
        </ReferenceInput>
      </FormTab>
      <FormTab label="photos">
        <Gallery source="gallery" />
      </FormTab>
    </TabbedForm>
  </Edit>
);

const DeleteTitle = ({ record }) => {
  return <span>{record ? `Διαγραφή του ${record.title}` : ""}</span>;
};

export const DeleteProduct = props => (
  <Delete title={<DeleteTitle />} {...props} />
);



// WEBPACK FOOTER //
// ./src/pages/companies/products.js